import { render, staticRenderFns } from "./allScorllPlace.vue?vue&type=template&id=1b5823cf&scoped=true&"
import script from "./allScorllPlace.vue?vue&type=script&lang=js&"
export * from "./allScorllPlace.vue?vue&type=script&lang=js&"
import style0 from "./allScorllPlace.vue?vue&type=style&index=0&id=1b5823cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5823cf",
  null
  
)

export default component.exports